import { useQuery } from '@tanstack/react-query';

export const GET_SYSTEM_VERSION = 'GetSystemVersion';

const SYSTEM_VERSION_URL =
  'https://sys.heidihealth.com/system-version/system-version.json';

type SystemVersionPayload = {
  systemVersion: string;
  meddeviceVersion?: string;
  meddeviceDate?: string;
  // The hosted file currently publishes the date under this name; tolerate
  // both spellings so the date renders whichever one the file carries.
  meddevicePublishedAt?: string;
};

export function useQuerySystemVersion({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({
    queryKey: [GET_SYSTEM_VERSION],
    queryFn: async (): Promise<SystemVersionPayload> => {
      const response = await fetch(SYSTEM_VERSION_URL);
      if (!response.ok) {
        throw new Error(`Failed to fetch system version: ${response.status}`);
      }
      return (await response.json()) as SystemVersionPayload;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 1,
    enabled,
  });

  return {
    ...query,
    data: query.data?.meddeviceVersion || query.data?.systemVersion,
    meddeviceVersion: query.data?.meddeviceVersion,
    meddeviceDate: query.data?.meddeviceDate ?? query.data?.meddevicePublishedAt,
  };
}
